import { FC, memo } from 'react';

import V2TrucksPresenter from './V2TrucksPresenter';

const V2Trucks: FC = memo(() => (
  <V2TrucksPresenter />
));

export default V2Trucks;
